import './echo';

import axios from 'axios';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;
axios.defaults.baseURL = import.meta.env.VITE_API_DOMAIN;

window.axios = axios;

// Disable console.logs in production
if (import.meta.env.VITE_APP_ENV === 'production') {
    console.log = function() {};
    console.warn = function() {};
    console.error = function() {};
}

import { createApp } from 'vue/dist/vue.esm-bundler';
import * as Sentry from "@sentry/vue";

import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faPlay, faPause, faCog, faUser, faSignOutAlt, faTimes, faMinus, faDiceD20, faVolumeUp, faVolumeMute, faStop,
    faUserSecret, faMusic, faExclamation, faCheckCircle, faExclamationCircle, faEyeSlash, faCopy, faUsers, faArrowLeft,
    faCircle, faBars, faArrowsAlt, faClock, faLock, faLockOpen, faInfoCircle, faCheck, faStepForward, faStepBackward
} from '@fortawesome/free-solid-svg-icons';
import {
    faMusicSlash, faUserCrown, faAlbum, faUserMusic, faExclamationSquare
} from '@fortawesome/pro-solid-svg-icons';
import { faSignalAlt } from '@fortawesome/pro-light-svg-icons';
import { faSmileBeam } from '@fortawesome/pro-regular-svg-icons';
// import { } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(
    faPlay, faPause, faCog, faUser, faSignOutAlt, faTimes, faMinus, faDiceD20, faVolumeUp, faVolumeMute, faStop,
    faUserSecret, faMusic, faMusicSlash, faSmileBeam, faSignalAlt, faExclamation, faCheckCircle, faExclamationCircle,
    faEyeSlash, faCopy, faUserCrown, faAlbum, faUserMusic, faUsers, faArrowLeft, faCircle, faBars, faArrowsAlt,
    faInfoCircle, faClock, faLock, faLockOpen, faExclamationSquare, faCheck, faStepForward, faStepBackward
);

// https://github.com/Maronato/vue-toastification/tree/next
import Toast, { POSITION } from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
const options = {
    // You can set your default options here
    position: POSITION.BOTTOM_CENTER,
    // timeout: false
};

import vueDebounce from 'vue-debounce';
import FloatingVue from 'floating-vue'

import AppTemplate from '@/views/template/Party.vue';

import HowlerPlugin from './howler';

const app = createApp(
    AppTemplate,
)
    .component('font-awesome-icon', FontAwesomeIcon)
    .use(Toast, options)
    .use(FloatingVue)
    .use(HowlerPlugin)
    .use(vueDebounce);

if (import.meta.env.VITE_APP_ENV === 'production') {
    Sentry.init({
        app,
        dsn: "https://7e232fe98725ba8469089a9a3804e717@o446607.ingest.sentry.io/4505662338957312",
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                networkDetailAllowUrls: [window.location.origin, 'api.bardica.com'],
            }),
            Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
        ],
        tracePropagationTargets: ["localhost", /^\//, /bardica\.com/],
        // Performance Monitoring
        tracesSampleRate: 0.1, // Capture 100% of the transactions, reduce in production!
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        enableLogs: true, // Set to true to enable console.log, console.info, console.warn, console.error, and console.debug messages to be sent to Sentry as breadcrumbs.
    });
} else {
    console.log("Sentry not loaded in development mode.");
}

app.mount('#app');
